<template>
  <v-app-bar color="secondary" prominent>
    <v-img src="@/assets/ciencia-technology-logo-transparent-no-padding.svg" class="ml-3" min-width="250px" max-width="250px" @click="$router.push({name: 'Dashboard'})" v-if="mdAndUp"/>
    <v-img src="@/assets/ciencia-technology-logo-transparent-symbol-only-no-padding.svg" class="ml-5" min-width="32px" max-width="32px" @click="$router.push({name: 'Dashboard'})" v-else/>

    <v-tabs v-model="selectedTab" align-tabs="center" grow show-arrows>
      <v-tab :id="menuPatientLevelData.key"
             :value="menuPatientLevelData.key"
             @click.prevent.stop.capture="patient_level_data_menu_drawer = toggleMenuDrawer(patient_level_data_menu_drawer)"
             :disabled="!isAuthenticated || !hasAccessRight('patient-level-data')"
             v-if="(isAuthenticated && hasAccessRight('patient-level-data')) || hasAccessRight('view-disabled-functions')">
        {{ menuPatientLevelData.title }}
      </v-tab>
      <v-tab :id="menuRegionalPatientData.key"
             :value="menuRegionalPatientData.key"
             @click.prevent.stop.capture="regional_patient_data_menu_drawer = toggleMenuDrawer(regional_patient_data_menu_drawer)"
             :disabled="!isAuthenticated || !hasAccessRight('socialstyrelsen-generic')"
             v-if="(isAuthenticated && hasAccessRight('socialstyrelsen-generic')) || hasAccessRight('view-disabled-functions')">
        {{ menuRegionalPatientData.title }}
      </v-tab>
      <v-tab :id="menuRegionalDrugDispensation.key"
             :value="menuRegionalDrugDispensation.key"
             @click.prevent.stop.capture="regional_drug_data_menu_drawer = toggleMenuDrawer(regional_drug_data_menu_drawer)"
             :disabled="!isAuthenticated || !hasAccessRight('socialstyrelsen-generic')"
             v-if="(isAuthenticated && hasAccessRight('socialstyrelsen-generic')) || hasAccessRight('view-disabled-functions')">
        {{ menuRegionalDrugDispensation.title }}
      </v-tab>
      <v-tab :id="menuClinicalTrials.key"
             :value="menuClinicalTrials.key"
             @click.prevent.stop.capture="clinical_trials_menu_drawer = toggleMenuDrawer(clinical_trials_menu_drawer)"
             :disabled="!isAuthenticated || !hasAccessRight('clinical-trials')"
             v-if="(isAuthenticated && hasAccessRight('clinical-trials')) || hasAccessRight('view-disabled-functions')">
        {{ menuClinicalTrials.title }}
      </v-tab>
      <v-tab :id="menuRwdLandscaping.key"
             :value="menuRwdLandscaping.key"
             @click.prevent.stop.capture="rwd_catalog_menu_drawer = toggleMenuDrawer(rwd_catalog_menu_drawer)"
             :disabled="!isAuthenticated || !hasAccessRight('data-landscaping')"
             v-if="(isAuthenticated && hasAccessRight('data-landscaping')) || hasAccessRight('view-disabled-functions')">
        {{ menuRwdLandscaping.title }}
      </v-tab>
      <v-tab :value="menuCustomStudies.key" @click="$router.push({name: 'CustomStudies'})"
             :disabled="!isAuthenticated || !hasAccessRight('custom-studies')"
             v-if="(isAuthenticated && hasAccessRight('custom-studies')) || hasAccessRight('view-disabled-functions')">
        {{ menuCustomStudies.title }}
      </v-tab>
      <v-tab :id="menuInternalTools.key"
             :value="menuInternalTools.key"
             @click.prevent.stop.capture="internal_tools_menu_drawer = toggleMenuDrawer(internal_tools_menu_drawer)"
             :disabled="!isAuthenticated || !hasAccessRight('internal-tools')"
             v-if="(isAuthenticated && hasAccessRight('internal-tools')) || hasAccessRight('view-disabled-functions')">
        {{ menuInternalTools.title }}
      </v-tab>
      <v-tab :value="menuVirtualPanels.key" @click="$router.push({name: 'VirtualPanels'})"
             :disabled="!isAuthenticated || !hasAnyAccessRight(['virtual-panel', 'virtual-panel-admin'])"
             v-if="(isAuthenticated && hasAccessRight('virtual-panel')) || hasAccessRight('view-disabled-functions')">
        {{ menuVirtualPanels.title }}
      </v-tab>
    </v-tabs>

    <v-spacer></v-spacer>

    <v-toolbar-title class="text-button">EpiX</v-toolbar-title>

    <!--<v-btn variant="text" icon="mdi-magnify"></v-btn>-->

    <v-btn variant="text" icon="mdi-dots-vertical" @click.stop="admin_menu_drawer = !admin_menu_drawer"></v-btn>
  </v-app-bar>

  <v-menu :activator="'#' + menuRwdLandscaping.key" v-model="rwd_catalog_menu_drawer"
          location="bottom" max-height="500px">
    <v-list v-model:opened="open_rwd_catalog_menu_items">
      <v-list-item title="Data Sources"
                   prepend-icon="mdi-database"
                   @click="$router.push({name: 'LandscapingDataSources'})"
                   :disabled="!isAuthenticated || !hasAccessRight('data-landscaping')"/>
      <v-list-item title="Key Clinics / Potential Partners"
                   prepend-icon="mdi-hospital-building"
                   @click="$router.push({name: 'LandscapingClinics'})"
                   :disabled="!isAuthenticated || !hasAccessRight('data-landscaping')"/>
    </v-list>
  </v-menu>

  <v-menu :activator="'#' + menuInternalTools.key" v-model="internal_tools_menu_drawer"
          location="bottom" max-height="500px">
    <v-list v-model:opened="open_internal_tools_menu_items">
      <v-list-item title="ICD10 Code Library"
                   prepend-icon="mdi-database"
                   @click="$router.push({name: 'IcdCodeProjectLibrary'})"
                   :disabled="!isAuthenticated || !hasAccessRight('internal-tools')"/>
      <v-list-item title="Pharma Pipelines"
                   prepend-icon="mdi-database"
                   @click="$router.push({name: 'PharmaPipelines'})"
                   :disabled="!isAuthenticated || !hasAccessRight('internal-tools')"/>
    </v-list>
  </v-menu>

  <v-menu :activator="'#' + menuPatientLevelData.key" v-model="patient_level_data_menu_drawer"
          location="bottom" max-height="500px">
    <v-list v-model:opened="open_patient_level_data_menu_items">
      <v-list-group v-for="item in patient_level_data_menu_items" :key="item.title" :value="item.title">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" prepend-icon="mdi-account-multiple-outline" :title="item.title"></v-list-item>
        </template>

        <v-list-item v-for="subitem in item.sub_menu_items"
                     :key="subitem.title"
                     :value="subitem.title"
                     :title="subitem.title"
                     :disabled="!icd10CodeAuthorized(subitem.icd10)"
                     @click="$router.push(subitem.route)">
          <v-list-item-subtitle>{{ subitem.sub_title }}</v-list-item-subtitle>
        </v-list-item>
        <v-divider></v-divider>
      </v-list-group>
    </v-list>
  </v-menu>

  <v-menu :activator="'#' + menuRegionalPatientData.key" v-model="regional_patient_data_menu_drawer"
          location="bottom" max-height="500px">
    <v-list v-model:opened="openRegionalDataMenuItems">
      <v-text-field v-model="regionalDataItemsSearch"
                    @click.stop="true"
                    @keydown.space.stop="() => {}"
                    @update:model-value="regionalDataItemsUpdated"
                    label="Search"
                    placeholder="Search"
                    :disabled="regionalDataItemsUnfiltered.size === 0"
                    hide-details filled dense></v-text-field>
      <RecursivePatientDataMenu :items="regionalDataItems" v-if="regionalDataItems.size > 0"/>
      <v-list-item v-else-if="regionalDataItemsUnfiltered.size > 0">No matches found.</v-list-item>
      <div class="text-center" v-else><v-progress-circular color="primary" indeterminate></v-progress-circular></div>
    </v-list>
  </v-menu>

  <v-menu :activator="'#' + menuRegionalDrugDispensation.key" v-model="regional_drug_data_menu_drawer"
          location="bottom" max-height="500px">
    <v-list v-model:opened="openRegionalDrugDataMenuItems">
      <v-text-field v-model="regionalDrugDataItemsSearch"
                    @click.stop="true"
                    @keydown.space.stop="() => {}"
                    @update:model-value="regionalDrugDataItemsUpdated"
                    label="Search"
                    placeholder="Search"
                    :disabled="regionalDrugDataItemsUnfiltered.size === 0"
                    hide-details filled dense></v-text-field>
      <RecursiveDrugsMenu :items="regionalDrugDataItems" v-if="regionalDrugDataItems.size > 0"/>
      <v-list-item v-else-if="regionalDrugDataItemsUnfiltered.size > 0">No matches found.</v-list-item>
      <div class="text-center" v-else><v-progress-circular color="primary" indeterminate></v-progress-circular></div>
    </v-list>
  </v-menu>

  <v-menu :activator="'#' + menuClinicalTrials.key" v-model="clinical_trials_menu_drawer"
          location="bottom" max-height="500px">
    <v-list v-model:opened="openClinicalTrialsMenuItems">
      <v-text-field v-model="clinicalTrialsItemsSearch"
                    @click.stop="true"
                    @keydown.space.stop="() => {}"
                    @update:model-value="clinicalTrialsItemsUpdated"
                    label="Search"
                    placeholder="Search"
                    :disabled="clinicalTrialsItemsUnfiltered.size === 0"
                    hide-details filled dense></v-text-field>
      <v-list-item title="All clinical trials"
                   @click="$router.push(({name: 'AllClinicalTrials', params: {}}))">
      </v-list-item>
      <RecursiveClinicalTrialsMenu :items="clinicalTrialsItems" v-if="clinicalTrialsItems.size > 0"/>
      <v-list-item v-else-if="clinicalTrialsItemsUnfiltered.size > 0">No matches found.</v-list-item>
      <div class="text-center" v-else><v-progress-circular color="primary" indeterminate></v-progress-circular></div>
    </v-list>
  </v-menu>

  <v-navigation-drawer v-model="admin_menu_drawer" location="right" temporary>
    <v-list v-model:opened="open_admin_menu_items">
      <v-list-item prepend-icon="mdi-account-circle" title="Profile"
                   @click="$router.push({name: 'Profile'})"
                   :disabled="!isAuthenticated"></v-list-item>
      <v-list-item prepend-icon="mdi-account-key" title="Credentials"
                   @click="$router.push({name: 'Credentials'})"
                   :disabled="!isAuthenticated"></v-list-item>
      <v-list-item prepend-icon="mdi-logout" title="Logout" @click="logoutWithConfirmation" v-if="isAuthenticated"></v-list-item>
      <v-list-item prepend-icon="mdi-login" title="Login" @click="logIn" v-if="!isAuthenticated"></v-list-item>
    </v-list>
  </v-navigation-drawer>

  <v-dialog v-model="dialogLogOut" max-width="500px">
    <v-card>
      <v-card-title>Confirm logging out</v-card-title>
      <v-card-text>Are you sure that you would like to log out?</v-card-text>
      <v-card-actions class="mt-10">
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="closeLogOut">Cancel</v-btn>
        <v-btn variant="text" @click="logOutConfirm">OK</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
  import { useDisplay } from 'vuetify'

  const { mdAndUp } = useDisplay()
</script>

<script>
import {defineComponent} from 'vue';
import axios from "axios";
import RecursiveDrugsMenu from "@/components/RecursiveDrugsMenu.vue";
import RecursivePatientDataMenu from "@/components/RecursivePatientDataMenu.vue";
import RecursiveClinicalTrialsMenu from "@/components/RecursiveClinicalTrialsMenu.vue";

const MENU_PATIENT_LEVEL_DATA = {
  key: 'patient-level-data',
  title: 'Real-World Data'
};

const MENU_REGIONAL_PATIENT_DATA = {
  key: 'regional-patient-data',
  title: 'Regional patient data'
};

const MENU_REGIONAL_DRUG_DISPENSATION = {
  key: 'regional-drug-dispensation',
  title: 'Regional drug dispensation'
};

const MENU_CLINICAL_TRIALS = {
  key: 'clinical-trials',
  title: 'Clinical trials'
};

const MENU_RWD_LANDSCAPING = {
  key: 'rwd-landscaping',
  title: 'RWD landscaping'
};

const MENU_CUSTOM_STUDIES = {
  key: 'custom-studies',
  title: 'Custom studies catalog'
};

const MENU_INTERNAL_TOOLS = {
  key: 'internal-tools',
  title: 'Internal tools'
};

const MENU_VIRTUAL_PANELS = {
  key: 'virtual-panels',
  title: 'Virtual panels'
};

function debounce(func, timer, timeout = 1000) {
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    return setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

function createMap(data) {
  let map = new Map();
  for (let key in data) {
    let value = Object.assign({}, data[key]);
    value.children = createMap(value.children);
    map.set(key, value);
  }
  return map
}

function filterMap(map, filter, keys) {
  let newMap = new Map();
  let newKeys = [];
  for (let [key, value] of map) {
    if (filter(value)) {
      newKeys.push(value.code);
      newMap.set(key, structuredClone(value));
      continue;
    }
    if (value.children) {
      let filteredChildren = filterMap(value.children, filter, keys);
      let newChildren = filteredChildren[0];
      if (newChildren.size > 0) {
        newKeys.push(value.code);
        newKeys.push(...filteredChildren[1])
        let copy = Object.assign({}, value);
        copy.children = newChildren;
        newMap.set(key, copy);
      }
    }
  }
  return [newMap, keys.concat(newKeys)];
}

export default defineComponent({
  name: 'NavBar',
  components: {
    RecursiveDrugsMenu,
    RecursivePatientDataMenu,
    RecursiveClinicalTrialsMenu
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {
    async logIn() {
      await this.$store.dispatch('logIn');
    },
    logoutWithConfirmation() {
      this.dialogLogOut = true;
    },
    async logout() {
      await this.$store.dispatch('logOut');
    },
    icd10CodeAuthorized(icd10Code) {
      return this.$store.getters.stateUser?.icd10_codes?.includes(icd10Code);
    },
    hasAnyAccessRight(accessRights) {
      return this.$store.getters.stateUser?.access_rights?.some(accessRight => accessRights.includes(accessRight));
    },
    hasAccessRight(accessRight) {
      return this.$store.getters.stateUser?.access_rights?.includes(accessRight);
    },
    async loadRegionalDataItems() {
      if (!this.hasAccessRight('socialstyrelsen-generic')) {
        return;
      }
      return axios.get('/socialstyrelsen-generic/diagnoses-tree',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
            }
          });
    },
    regionalDataItemsUpdated() {
      this.regionalDataItemsSearchTimer = debounce(() => {
        if (this.regionalDataItemsSearch === '') {
          this.regionalDataItems = structuredClone(this.regionalDataItemsUnfiltered);
          return;
        }
        let keys = [];
        let filteredMap = filterMap(this.regionalDataItemsUnfiltered, item =>
            item.diagnosis.toLowerCase().includes(this.regionalDataItemsSearch.toLowerCase()) ||
            item.code.toLowerCase().includes(this.regionalDataItemsSearch.toLowerCase()), keys)
        this.regionalDataItems = filteredMap[0];
        this.openRegionalDataMenuItems = filteredMap[1];
      }, this.regionalDataItemsSearchTimer)()
    },
    async loadRegionalDrugDataItems() {
      if (!this.hasAccessRight('socialstyrelsen-generic')) {
        return;
      }
      return axios.get('/socialstyrelsen-generic/atc-tree',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
            }
          });
    },
    regionalDrugDataItemsUpdated() {
      this.regionalDrugDataItemsSearchTimer = debounce(() => {
        if (this.regionalDrugDataItemsSearch === '') {
          this.regionalDrugDataItems = structuredClone(this.regionalDrugDataItemsUnfiltered);
          return;
        }
        let keys = [];
        let filteredMap = filterMap(this.regionalDrugDataItemsUnfiltered, item =>
            item.description.toLowerCase().includes(this.regionalDrugDataItemsSearch.toLowerCase()) ||
            item.code.toLowerCase().includes(this.regionalDrugDataItemsSearch.toLowerCase()), keys)
        this.regionalDrugDataItems = filteredMap[0];
        this.openRegionalDrugDataMenuItems = filteredMap[1];
      }, this.regionalDrugDataItemsSearchTimer)()
    },
    async loadClinicalTrials() {
      if (!this.hasAccessRight('clinical-trials')) {
        return;
      }
      return axios.get('/mesh-codes',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
            }
          });
    },
    clinicalTrialsItemsUpdated() {
      this.clinicalTrialsItemsSearchTimer = debounce(() => {
        if (this.clinicalTrialsItemsSearch === '') {
          this.clinicalTrialsItems = structuredClone(this.clinicalTrialsItemsUnfiltered);
          return;
        }
        let keys = [];
        let filteredMap = filterMap(this.clinicalTrialsItemsUnfiltered, item =>
            item.description.toLowerCase().includes(this.clinicalTrialsItemsSearch.toLowerCase()) ||
            item.code.toLowerCase().includes(this.clinicalTrialsItemsSearch.toLowerCase()), keys)
        this.clinicalTrialsItems = filteredMap[0];
        this.openClinicalTrialsMenuItems = filteredMap[1];
      }, this.clinicalTrialsItemsSearchTimer)()
    },
    closeLogOut() {
      this.dialogLogOut = false;
    },
    logOutConfirm() {
      this.logout().then(() => {
        this.dialogLogOut = false;
      });
    },
    toggleMenuDrawer(menu_drawer_value) {
      this.patient_level_data_menu_drawer = false;
      this.regional_patient_data_menu_drawer = false;
      this.regional_drug_data_menu_drawer = false;
      this.clinical_trials_menu_drawer = false;
      this.rwd_catalog_menu_drawer = false;
      this.internal_tools_menu_drawer = false;
      return !menu_drawer_value;
    }
  },
  data: () => ({
    dialogLogOut: false,
    selectedTab: null,
    rwd_catalog_menu_drawer: false,
    internal_tools_menu_drawer: false,
    patient_level_data_menu_drawer: false,
    regional_patient_data_menu_drawer: false,
    regional_drug_data_menu_drawer: false,
    clinical_trials_menu_drawer: false,
    admin_menu_drawer: false,
    group: null,
    open_rwd_catalog_menu_items: [],
    open_internal_tools_menu_items: [],
    open_patient_level_data_menu_items: [],
    open_admin_menu_items: [],
    menuPatientLevelData: MENU_PATIENT_LEVEL_DATA,
    menuRegionalPatientData: MENU_REGIONAL_PATIENT_DATA,
    menuRegionalDrugDispensation: MENU_REGIONAL_DRUG_DISPENSATION,
    menuClinicalTrials: MENU_CLINICAL_TRIALS,
    menuRwdLandscaping: MENU_RWD_LANDSCAPING,
    menuCustomStudies: MENU_CUSTOM_STUDIES,
    menuInternalTools: MENU_INTERNAL_TOOLS,
    menuVirtualPanels: MENU_VIRTUAL_PANELS,
    menusByKey: new Map([
      [MENU_PATIENT_LEVEL_DATA.key, MENU_PATIENT_LEVEL_DATA],
      [MENU_REGIONAL_PATIENT_DATA.key, MENU_REGIONAL_PATIENT_DATA],
      [MENU_REGIONAL_DRUG_DISPENSATION.key, MENU_REGIONAL_DRUG_DISPENSATION],
      [MENU_CLINICAL_TRIALS.key, MENU_CLINICAL_TRIALS],
      [MENU_RWD_LANDSCAPING.key, MENU_RWD_LANDSCAPING],
      [MENU_CUSTOM_STUDIES.key, MENU_CUSTOM_STUDIES],
      [MENU_INTERNAL_TOOLS.key, MENU_INTERNAL_TOOLS],
      [MENU_VIRTUAL_PANELS.key, MENU_VIRTUAL_PANELS]
    ]),
    patient_level_data_menu_items: [
      {
        title: 'C00-D48 Neoplasms',
        sub_menu_items: [
          {
            title: 'C18, C19, or C20: De novo metastatic colorectal cancer',
            sub_title: '',
            icd10: 'C18_C19_C20',
            route: ({name: 'C18_C19_C20'})
          },
          {
            title: 'C34: Malignant neoplasm of bronchus and lung',
            sub_title: '',
            icd10: 'C34',
            route: ({name: 'C34'})
          },
          {
            title: 'C34: Malignant neoplasm of bronchus and lung (sample)',
            sub_title: '',
            icd10: 'C34sample',
            route: ({name: 'C34sample'})
          },
          {
            title: 'C90.0: Multiple myeloma',
            sub_title: '',
            icd10: 'C90.0',
            route: ({name: 'C90.0'})
          },
          {
            title: 'C90.0: Multiple myeloma (sample)',
            sub_title: '',
            icd10: 'C90.0sample',
            route: ({name: 'C90.0sample'})
          }
        ]
      },
      {
        title: 'E00-E90 Endocrine, nutritional and metabolic diseases',
        sub_menu_items: [
          {
            title: 'E75.2F: Fabry disease',
            sub_title: '',
            icd10: 'E75.2F',
            route: ({name: 'E75.2F'})
          }
        ]
      },
      {
        title: 'G00-G99 Diseases of the nervous system',
        sub_menu_items: [
          {
            title: 'G70.0: Myasthenia gravis',
            sub_title: '',
            icd10: 'G70.0',
            route: ({name: 'G70.0'})
          }
        ]
      }
    ],
    regionalDataItemsSearch: '',
    regionalDataItemsSearchTimer: undefined,
    regionalDataItems: new Map(),
    regionalDataItemsUnfiltered: new Map(),
    openRegionalDataMenuItems: [],
    regionalDrugDataItemsSearch: '',
    regionalDrugDataItemsSearchTimer: undefined,
    regionalDrugDataItems: new Map(),
    regionalDrugDataItemsUnfiltered: new Map(),
    openRegionalDrugDataMenuItems: [],
    clinicalTrialsItemsSearch: '',
    clinicalTrialsItemsSearchTimer: undefined,
    clinicalTrialsItems: new Map(),
    clinicalTrialsItemsUnfiltered: new Map(),
    openClinicalTrialsMenuItems: []
  }),
  watch: {
    group() {
      this.internal_tools_menu_drawer = false
      this.rwd_catalog_menu_drawer = false
      this.patient_level_data_menu_drawer = false
      this.admin_menu_drawer = false
    },
    $route(to) {
      if (to && to.meta && this.menusByKey.get(to.meta.menuKey)) {
        let selectedMenu = this.menusByKey.get(to.meta.menuKey)
        this.selectedTab = selectedMenu.key
      } else {
        this.selectedTab = null
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.loadRegionalDataItems(),
      this.loadRegionalDrugDataItems(),
      this.loadClinicalTrials()
    ]).then(responses => {
      if (responses[0]) {
        this.regionalDataItemsUnfiltered = createMap(responses[0].data);
        this.regionalDataItems = structuredClone(this.regionalDataItemsUnfiltered);
      }
      if (responses[1]) {
        this.regionalDrugDataItemsUnfiltered = createMap(responses[1].data)
        this.regionalDrugDataItems = structuredClone(this.regionalDrugDataItemsUnfiltered);
      }
      if (responses[2]) {
        this.clinicalTrialsItemsUnfiltered = createMap(responses[2].data)
        this.clinicalTrialsItems = structuredClone(this.clinicalTrialsItemsUnfiltered);
      }
      console.log('NavBar menu items loaded');
    })
  }
});
</script>
